var React = require('react');

function Star (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"star","x1":"0%","y1":"0%","y2":"100%"},[React.createElement("stop",{"offset":"0%","stopColor":"#FFFF8F","key":0}),React.createElement("stop",{"offset":"100%","stopColor":"#FF7D50","key":1})])),React.createElement("path",{"fill":"url(#star)","fillRule":"evenodd","d":"M15 67l-5.878 3.09 1.123-6.545-4.756-4.635 6.572-.955L15 52l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z","transform":"translate(-5 -52)","key":1})]);
}

Star.defaultProps = {"width":"20","height":"19","viewBox":"0 0 20 19"};

module.exports = Star;

Star.default = Star;
